/* Observe et stocke le scroll Y */

const updateScrollTopVar = () => {
    const y = window.scrollY || window.pageYOffset || 0;
    if (y > 0) document.documentElement.style.setProperty('--scroll-y', `${y}px`);
};

let ticking = false;
const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
        updateScrollTopVar();
        ticking = false;
    });
};

window.addEventListener('scroll', onScroll, { passive: true });
updateScrollTopVar(); // init au chargement

/**
 * Observer une classe sur <html> : enregistre scrollY dans une variable CSS,
 * restaure le scroll à la suppression de la classe.
 * Le position:fixed du body est géré ailleurs (CSS).
 *
 * initHtmlClassScrollVar({ className: 'lock-all', varName: '--scroll-y' });
 */

document.addEventListener('DOMContentLoaded', function () {
    var className = 'lock-all';
    var varName = '--scroll-y';
    var observer = null;
    var locked = false;

    initHtmlClassScrollVar({ className: className, varName: varName });

    function readY() {
        return window.scrollY || window.pageYOffset || 0;
    }

    function onClassChange() {
        console.log('onClassChange');
        var has = document.documentElement.classList.contains(className);
        if (has && !locked) {
            locked = true;
        } else if (!has && locked) {
            locked = false;
            var raw = document.documentElement.style.getPropertyValue(varName).trim();
            var y = parseFloat(raw) || 0;
            window.scrollTo({
                top: y,
                left: 0,
                behavior: "instant",
            });
        }
    }

    function initHtmlClassScrollVar(opts) {
        if (window.innerWidth > 999) return;
        
        if (opts && opts.className) className = opts.className;
        if (opts && opts.varName) varName = opts.varName;

        destroyHtmlClassScrollVar();

        observer = new MutationObserver(onClassChange);
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['class'],
        });

        locked = false;
        if (document.documentElement.classList.contains(className)) {
            onClassChange();
        }
    }

    function destroyHtmlClassScrollVar() {
        if (observer) {
            observer.disconnect();
            observer = null;
        }
        if (locked) {
            locked = false;
            document.documentElement.style.removeProperty(varName);
        }
    }
});